import { history } from '../../constants';

export function useHistory() {
  return history;
}
